import { createContext, useContext } from '@wordpress/element';
export const TabsContext = createContext(undefined);
TabsContext.displayName = 'TabsContext';
export const useTabsContext = () => useContext(TabsContext);